import { IInvestmentInfo } from '@/modules/transaction/services/fund-pension-investment';

export function errorText(data: IInvestmentInfo, inputValue: number) {
  const { minimumInvestment, accountBalance } = data;

  if (inputValue > accountBalance.value) {
    return 'Valor maior que o saldo em conta';
  }

  if (inputValue > 0 && inputValue < minimumInvestment.value) {
    return 'Valor menor que o mínimo para investir';
  }

  return '';
}

export function errorStatus(data: IInvestmentInfo, inputValue: number) {
  const { minimumInvestment, accountBalance } = data;

  if (inputValue > accountBalance.value) {
    return 'error';
  }

  if (inputValue > 0 && inputValue < minimumInvestment.value) {
    return 'error';
  }

  return '';
}

export function listDetails(data: IInvestmentInfo) {
  const { minimumInvestment, investmentWindow, currentBalance } = data;

  const list = [
    {
      label: currentBalance?.label || '',
      value: currentBalance?.formatted || '',
      loading: false,
      show: Boolean(currentBalance)
    },
    {
      label: minimumInvestment.label,
      value: minimumInvestment.formatted,
      loading: false,
      show: Boolean(minimumInvestment)
    },
    {
      label: investmentWindow.label,
      value: investmentWindow.value,
      loading: false,
      show: Boolean(investmentWindow)
    }
  ];

  return list.filter(item => item.show);
}
